const reveal = () => {
    let elements,
        windowHeight

    const init = () => {
        elements = document.querySelectorAll('.target-hidden')
        windowHeight = window.innerHeight
    }

    const checkPosition = () => {
        for (let i=0, lng=elements.length; i<lng; i++) {
            let element         = elements[i],
                positionFromTop = elements[i].getBoundingClientRect().top

            if (positionFromTop - windowHeight <= 0) {
                element.classList.add('target-reveal')
                element.classList.remove('target-hidden')
            }
        }
    }

    window.addEventListener('scroll', checkPosition)
    window.addEventListener('resize', init)

    init()
    checkPosition()
}

export {
    reveal
}